/** Konstanta pro dragging eventy v DraggableTree. */
export const DRAG_TRANSFER_KEY = "DRAGGABLE_TREE_DATA_TRANSFER_KEY";
/** Doba v ms, po kterou se má počkat s vykonáním DragOver události. */
export const DEBOUNCE_TIME_DELAY = 60;
